import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CustomersTable from './customers-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-view-customer')) {
  let customerId = document.getElementById('react-component-g4-logistics-portal-view-customer').getAttribute('data-customer-id');
  ReactDOM.render(<CustomersTable
      url = {"/api/v1/portal/customers/view/"+customerId}
      viewJustOneCustomer = {true}
      message_if_none = 'Customer not found or available for viewing.'
    />,

    document.getElementById('react-component-g4-logistics-portal-view-customer'));
}
